import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { FaGraduationCap, FaChartBar, FaMedal, FaPlusCircle, FaInbox, FaTrash, FaEdit,  } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Education() {
  // ...existing state...
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [actionLoading, setActionLoading] = React.useState(false);
  const [actionError, setActionError] = React.useState('');

  // Delete modal state
  const [deleteModal, setDeleteModal] = React.useState({ open: false, id: null });

  // Delete handler
  async function confirmDeleteQuestion() {
    if (!deleteModal.id) return;
    setActionLoading(true);
    setActionError('');
    try {
      const res = await fetch('https://dev.sliitleo.org/Backend/delete_question.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: deleteModal.id })
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Delete failed');
      setDeleteModal({ open: false, id: null });
      fetchQuestions();
    } catch (err) {
      setActionError(err.message);
    } finally {
      setActionLoading(false);
    }
  }

  function handleDeleteQuestion(id) {
    setDeleteModal({ open: true, id });
  }

  // Edit handler
  function handleEditQuestion(q) {
    setEditData(q);
    setEditModalOpen(true);
  }

  async function handleUpdateQuestion(e) {
    e.preventDefault();
    setActionLoading(true);
    setActionError('');
    try {
      const res = await fetch('https://dev.sliitleo.org/Backend/update_question.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editData)
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Update failed');
      setEditModalOpen(false);
      fetchQuestions();
    } catch (err) {
      setActionError(err.message);
    } finally {
      setActionLoading(false);
    }
  }
  // Filter state
  const [filterSubject, setFilterSubject] = React.useState('');
  const [filterQuiz, setFilterQuiz] = React.useState('');
  // Form state and feedback
  const [formData, setFormData] = useState({
    subject: '',
    quiz: '',
    question: '',
    option1: '',
    option2: '',
    option3: '',
    option4: '',
    correct_option: '1',
    explanation: ''
  });
  const [quizDisabled, setQuizDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // For displaying all questions
  const [questions, setQuestions] = useState([]);
  const [questionsLoading, setQuestionsLoading] = useState(true);
  const [questionsError, setQuestionsError] = useState('');

  // Fetch questions on mount and after adding new
  const fetchQuestions = async () => {
    setQuestionsLoading(true);
    setQuestionsError('');
    try {
      const res = await fetch('https://dev.sliitleo.org/Backend/get_questions.php');
      const data = await res.json();
      if (data.success) {
        setQuestions(data.questions);
      } else {
        setQuestionsError(data.error || 'Failed to load questions.');
      }
    } catch (err) {
      setQuestionsError('Network error.');
    }
    setQuestionsLoading(false);
  };
  React.useEffect(() => { fetchQuestions(); }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === "subject") {
      if (value === "Club History") {
        setFormData(prev => ({ ...prev, subject: value, quiz: "Quiz 1: Milestones of Leo Club of SLIIT" }));
        setQuizDisabled(true);
      }
      else if (value === "Leo History") {
        setFormData(prev => ({ ...prev, subject: value, quiz: "Quiz 2: The Journey of Leoism Worldwide" }));
        setQuizDisabled(true);
      }
      else if (value === "Lions International") {
        setFormData(prev => ({ ...prev, subject: value, quiz: "Quiz 3: How Lions Clubs Changed the World" }));
        setQuizDisabled(true);
      }
      else {
        setFormData(prev => ({ ...prev, subject: value, quiz: "" }));
        setQuizDisabled(false);
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };


  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');
    try {
      const response = await fetch('https://dev.sliitleo.org/Backend/add_question.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      if (data.success) {
        setSuccess(data.message || 'Question added successfully!');
        setFormData({
          subject: '',
          quiz: '',
          question: '',
          option1: '',
          option2: '',
          option3: '',
          option4: '',
          correct_option: '1',
          explanation: ''
        });
        fetchQuestions(); // Refresh questions list
      } else {
        setError(data.error || 'Something went wrong.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
    setLoading(false);
  };


 const user = JSON.parse(localStorage.getItem('user')) || {
    name: 'Unknown User',
    role: 'Member',
    image: '/default-user.png',
  };
  return (
    <div className="flex flex-col md:flex-row bg-[#111827] text-white min-h-screen">
      <Sidebar className="hidden md:block" />
      <Topbar user={user} />
      <main className="md:ml-64 mt-14 w-full px-4 sm:px-6 md:px-8 py-6 md:py-10">
        {/* Header */}
        <div className="backdrop-blur-md bg-gradient-to-r from-[#23272f]/80 to-[#181b20]/80 border border-gray-800 rounded-2xl p-4 md:p-5 mb-6 md:mb-8 flex items-center gap-3 md:gap-4 shadow-lg">
          <span className="flex items-center gap-2 md:gap-3">
            <span className="bg-indigo-600 p-1.5 md:p-2 rounded-full shadow-lg flex items-center justify-center">
              <FaGraduationCap className="text-white text-xl md:text-2xl" />
            </span>
            <span className="text-base md:text-lg font-bold tracking-wide text-white drop-shadow">
              Education Admin<span className="text-gray-400 font-normal"> / Quiz Question</span>
            </span>
          </span>
        </div>

        {/* Navigation Buttons */}
        <div className="mb-6 md:mb-8">
          <div className="flex flex-wrap gap-2 sm:gap-3">
            <Link to="/education-statistics" className="flex-1 sm:flex-none flex items-center justify-center gap-1 sm:gap-2 bg-[#23272f] px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-lg sm:rounded-xl text-sm sm:text-base font-semibold text-white border border-gray-700 shadow hover:scale-[1.02] sm:hover:scale-105 transition focus:outline-none focus:ring-2 focus:ring-orange-400 group">
              <span className="text-orange-400 text-lg sm:text-xl"><FaChartBar /></span>
              <span className="truncate">Statistics</span>
            </Link>
            <Link to="/education-leaderboard" className="flex-1 sm:flex-none flex items-center justify-center gap-1 sm:gap-2 bg-[#23272f] px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-lg sm:rounded-xl text-sm sm:text-base font-semibold text-white border border-gray-700 shadow hover:scale-[1.02] sm:hover:scale-105 transition focus:outline-none focus:ring-2 focus:ring-blue-400 group">
              <span className="text-blue-400 text-lg sm:text-xl"><FaMedal /></span>
              <span className="truncate">Leaderboard</span>
            </Link>
            <Link to="/education-add-quiz-question" className="flex-1 sm:flex-none flex items-center justify-center gap-1 sm:gap-2 bg-indigo-600 px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-lg sm:rounded-xl text-sm sm:text-base font-semibold text-white border border-indigo-500 shadow hover:scale-[1.02] sm:hover:scale-105 transition focus:outline-none focus:ring-2 focus:ring-red-400 group">
              <span className="text-white text-lg sm:text-xl"><FaPlusCircle /></span>
              <span className="truncate">Add Quiz</span>
            </Link>
          </div>
        </div>

        {/* Add New Question Form */}
        <div className="bg-[#23272f] rounded-xl p-4 sm:p-6 md:p-8 shadow-lg border border-gray-800 mb-8">
          <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Add New Quiz Question</h2>
          <form className="space-y-3 sm:space-y-4" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm text-gray-300">Subject</label>
                <select 
                  name="subject" 
                  value={formData.subject} 
                  onChange={handleChange} 
                  className="w-full text-sm sm:text-base rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
                  required
                >
                  <option value="">Select Subject</option>
                  <option value="Club History">Club History</option>
                  <option value="Leo History">Leo History</option>
                  <option value="Lions International">Lions International</option>
                </select>
              </div>
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm text-gray-300">Quiz Name</label>
                <select 
                  name="quiz" 
                  value={formData.quiz} 
                  onChange={handleChange} 
                  className="w-full text-sm sm:text-base rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:opacity-60" 
                  required 
                  disabled={quizDisabled}
                >
                  <option value="">Select Quiz</option>
                  <option value="Quiz 1: Milestones of Leo Club of SLIIT">Quiz 1: Milestones of Leo Club of SLIIT</option>
                  <option value="Quiz 2: The Journey of Leoism Worldwide">Quiz 2: The Journey of Leoism Worldwide</option>
                  <option value="Quiz 3: How Lions Clubs Changed the World">Quiz 3: How Lions Clubs Changed the World</option>
                </select>
              </div>
              
              <div className="md:col-span-2 space-y-1">
                <label className="block text-xs sm:text-sm text-gray-300">Question</label>
                <input 
                  type="text" 
                  name="question" 
                  value={formData.question} 
                  onChange={handleChange} 
                  className="w-full text-sm sm:text-base rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
                  required 
                />
              </div>
              
              {[1, 2, 3, 4].map((num) => (
                <div key={num} className="space-y-1">
                  <label className="block text-xs sm:text-sm text-gray-300">Option {num}</label>
                  <input 
                    type="text" 
                    name={`option${num}`} 
                    value={formData[`option${num}`]} 
                    onChange={handleChange} 
                    className="w-full text-sm sm:text-base rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
                    required 
                  />
                </div>
              ))}
              
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm text-gray-300">Correct Option</label>
                <select 
                  name="correct_option" 
                  value={formData.correct_option} 
                  onChange={handleChange} 
                  className="w-full text-sm sm:text-base rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
                  required
                >
                  {[1, 2, 3, 4].map(num => (
                    <option key={num} value={num.toString()}>Option {num}</option>
                  ))}
                </select>
              </div>
              
              <div className="md:col-span-2 space-y-1">
                <label className="block text-xs sm:text-sm text-gray-300">
                  Explanation <span className="text-gray-400">(optional)</span>
                </label>
                <textarea 
                  name="explanation" 
                  value={formData.explanation} 
                  onChange={handleChange} 
                  className="w-full text-sm sm:text-base rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
                  rows="2"
                ></textarea>
              </div>
            </div>
            
            <div className="pt-2">
              <button 
                type="submit" 
                className="w-full sm:w-auto px-6 py-2 rounded bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-sm sm:text-base transition-colors" 
                disabled={loading}
              >
                {loading ? 'Adding...' : 'Add Question'}
              </button>
              {success && (
                <div className="mt-3 p-2 bg-green-900/30 text-green-400 text-sm sm:text-base rounded border border-green-800">
                  {success}
                </div>
              )}
              {error && (
                <div className="mt-3 p-2 bg-red-900/30 text-red-400 text-sm sm:text-base rounded border border-red-800">
                  {error}
                </div>
              )}
            </div>
          </form>
        </div>
        <br/>
        {/* Questions List */}
        <div className="bg-[#23272f] rounded-xl p-4 sm:p-6 md:p-8 shadow-lg border border-gray-800">
          <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Questions List</h2>
          
          {questions.length === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <FaInbox className="mx-auto text-4xl mb-3 opacity-50" />
              <p>No questions added yet</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full bg-[#1e222a] rounded-lg overflow-hidden">
                <thead className="hidden sm:table-header-group">
                  <tr className="bg-gray-800 text-gray-300 text-xs sm:text-sm">
                    <th className="py-2 sm:py-3 px-2 sm:px-4 text-left">#</th>
                    <th className="py-2 sm:py-3 px-2 sm:px-4 text-left">Subject</th>
                    <th className="py-2 sm:py-3 px-2 sm:px-4 text-left hidden md:table-cell">Quiz</th>
                    <th className="py-2 sm:py-3 px-2 sm:px-4 text-left">Question</th>
                    <th className="py-2 sm:py-3 px-2 sm:px-4 text-right">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-700">
                  {questions.map((q, index) => (
                    <tr key={q.id} className="hover:bg-gray-800/50 transition-colors">
                      <td className="py-3 px-2 sm:px-4 text-gray-300 text-xs sm:text-sm">
                        <span className="sm:hidden font-medium text-gray-400 mr-2">#</span>
                        {index + 1}
                      </td>
                      <td className="py-3 px-2 sm:px-4 text-gray-300 text-xs sm:text-sm">
                        <span className="sm:hidden font-medium text-gray-400 mr-2">Subject:</span>
                        <span className="line-clamp-1">{q.subject}</span>
                      </td>
                      <td className="py-3 px-2 sm:px-4 text-gray-300 text-xs sm:text-sm hidden md:table-cell">
                        <span className="line-clamp-1">{q.quiz}</span>
                      </td>
                      <td className="py-3 px-2 sm:px-4 text-gray-300 text-xs sm:text-sm">
                        <span className="sm:hidden font-medium text-gray-400 mr-2">Question:</span>
                        <span className="line-clamp-2">{q.question}</span>
                      </td>
                      <td className="py-3 px-2 sm:px-4">
                        <div className="flex justify-end space-x-1 sm:space-x-2">
                          <button 
                            onClick={() => handleEditQuestion(q)} 
                            className="p-1 sm:p-1.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white transition-colors"
                            aria-label="Edit question"
                          >
                            <FaEdit className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                          </button>
                          <button 
                            onClick={() => handleDeleteQuestion(q.id)} 
                            className="p-1 sm:p-1.5 rounded-full bg-red-600 hover:bg-red-700 text-white transition-colors"
                            aria-label="Delete question"
                          >
                            <FaTrash className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          
          {questions.length > 0 && (
            <div className="mt-4 text-xs sm:text-sm text-gray-400">
              Showing {questions.length} {questions.length === 1 ? 'question' : 'questions'}
            </div>
          )}
        </div>
        
        {/* Filter Controls */}
        <div className="bg-[#23272f] rounded-xl p-4 sm:p-6 mb-6 border border-gray-800">
          <h3 className="text-sm font-medium text-gray-300 mb-3">Filter Questions</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs text-gray-400 mb-1">Subject</label>
              <select
                value={filterSubject}
                onChange={e => setFilterSubject(e.target.value)}
                className="w-full text-sm rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              >
                <option value="">All Subjects</option>
                {[...new Set(questions.map(q => q.subject))].map(subject => (
                  <option key={subject} value={subject}>{subject}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-400 mb-1">Quiz</label>
              <select
                value={filterQuiz}
                onChange={e => setFilterQuiz(e.target.value)}
                className="w-full text-sm rounded px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              >
                <option value="">All Quizzes</option>
                {[...new Set(questions.map(q => q.quiz))].map(quiz => (
                  <option key={quiz} value={quiz}>{quiz}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        
        {/* Filtered Questions List */}
        {questionsLoading ? (
          <div className="text-center py-8 text-gray-400">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-indigo-500 mb-2"></div>
            <p>Loading questions...</p>
          </div>
        ) : questionsError ? (
          <div className="p-4 bg-red-900/30 text-red-400 rounded border border-red-800">
            {questionsError}
          </div>
        ) : questions.filter(q => 
          (filterSubject === '' || q.subject === filterSubject) &&
          (filterQuiz === '' || q.quiz === filterQuiz)
        ).length === 0 ? (
          <div className="text-center py-8 text-gray-400">
            <FaInbox className="mx-auto text-4xl mb-3 opacity-50" />
            <p>No questions match the selected filters</p>
          </div>
        ) : (
          <div className="space-y-4">
            {questions
              .filter(q => 
                (filterSubject === '' || q.subject === filterSubject) &&
                (filterQuiz === '' || q.quiz === filterQuiz)
              )
              .map(q => (
                <div
                  key={q.id}
                  className="relative group bg-gradient-to-br from-[#23272f]/90 to-[#181b20]/90 border-l-4 border-indigo-500 rounded-xl p-5 mb-2 shadow-lg transition-transform hover:scale-[1.025] hover:shadow-2xl"
                >
                  {/* Action buttons */}
                  <div className="absolute top-4 right-4 flex gap-2 opacity-80 group-hover:opacity-100 transition-opacity z-10">
                    <button
                      className="p-2 rounded-full bg-blue-700 hover:bg-blue-800 text-white shadow focus:outline-none"
                      title="Update"
                      onClick={() => handleEditQuestion(q)}
                    >
                      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor"><path d="M17.414 2.586a2 2 0 00-2.828 0l-9.5 9.5A2 2 0 004 13.914V16a1 1 0 001 1h2.086a2 2 0 001.414-.586l9.5-9.5a2 2 0 000-2.828l-1.5-1.5zM5 15v-1.586l8.293-8.293 1.586 1.586L6.586 15H5zm10.707-9.293a1 1 0 010 1.414l-.793.793-1.586-1.586.793-.793a1 1 0 011.414 0z"/></svg>
                    </button>
                    <button
                      className="p-2 rounded-full bg-red-700 hover:bg-red-800 text-white shadow focus:outline-none"
                      title="Delete"
                      onClick={() => handleDeleteQuestion(q.id)}
                    >
                      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor"><path d="M6 8a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 1a1 1 0 10-2 0v6a1 1 0 102 0V9z"/><path fillRule="evenodd" d="M4 5a1 1 0 011-1h10a1 1 0 011 1v1H4V5zm2-3a1 1 0 00-1 1v1h10V3a1 1 0 00-1-1H6z" clipRule="evenodd"/></svg>
                    </button>
                  </div>
                  <div className="flex items-center gap-3 mb-3">
                    <span className="bg-indigo-600 p-2 rounded-full flex items-center justify-center text-white text-lg shadow">
                      <i className="fa fa-book-open" />
                    </span>
                    <span className="font-bold text-lg text-white flex-1">{q.question}</span>
                  </div>
                  <div className="flex flex-wrap items-center gap-0 mb-3 mt-2">
                    {[q.option1, q.option2, q.option3, q.option4].map((opt, idx, arr) => (
                      <React.Fragment key={idx}>
                        <div
                          className={`flex items-center gap-2 px-4 py-2 rounded-lg ${parseInt(q.correct_option) === idx + 1 ? 'bg-green-900/40 text-green-300 font-semibold' : 'bg-gray-800/60 text-gray-300'} text-sm`}
                        >
                          {parseInt(q.correct_option) === idx + 1 ? (
                            <span className="text-green-400 mr-2"><svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"><path d="M20 7L10.5 17L4 10.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
                          ) : null}
                          {String.fromCharCode(65 + idx)}. {opt}
                        </div>
                        {idx < arr.length - 1 && <span className="text-gray-600 mx-1">|</span>}
                      </React.Fragment>
                    ))}
                  </div>
                  {/* {q.explanation && (
                    <div className="mb-2 text-xs text-blue-300 bg-blue-900/40 rounded px-3 py-1">Explanation: {q.explanation}</div>
                  )} */}
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mt-3 text-xs text-gray-400 gap-1 sm:gap-0">
                    <span className="bg-gray-800/50 px-2 py-1 rounded">{q.subject}</span>
                    <span className="text-gray-500 text-2xs sm:text-xs">{q.quiz}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
  
      {/* Edit Modal */}
      {editModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <form
            onSubmit={handleUpdateQuestion}
            className="bg-[#23272f] border border-gray-700 rounded-xl p-8 w-full max-w-lg relative shadow-xl"
          >
            <button
              type="button"
              className="absolute top-2 right-2 text-gray-400 hover:text-white text-xl"
              onClick={() => setEditModalOpen(false)}
              title="Close"
            >
              ×
            </button>
            <h3 className="text-lg font-bold mb-4 text-white">Update Question</h3>
            <div className="grid grid-cols-1 gap-3">
              <input
                className="rounded px-3 py-2 bg-gray-800 text-white border border-gray-700"
                placeholder="Subject"
                value={editData.subject}
                onChange={e => setEditData({ ...editData, subject: e.target.value })}
                required
              />
              <input
                className="rounded px-3 py-2 bg-gray-800 text-white border border-gray-700"
                placeholder="Quiz"
                value={editData.quiz}
                onChange={e => setEditData({ ...editData, quiz: e.target.value })}
                required
              />
              <textarea
                className="rounded px-3 py-2 bg-gray-800 text-white border border-gray-700"
                placeholder="Question"
                value={editData.question}
                onChange={e => setEditData({ ...editData, question: e.target.value })}
                required
              />
              {[1,2,3,4].map(i => (
                <input
                  key={i}
                  className="rounded px-3 py-2 bg-gray-800 text-white border border-gray-700"
                  placeholder={`Option ${i}`}
                  value={editData[`option${i}`]}
                  onChange={e => setEditData({ ...editData, [`option${i}`]: e.target.value })}
                  required
                />
              ))}
              <select
                className="rounded px-3 py-2 bg-gray-800 text-white border border-gray-700"
                value={editData.correct_option}
                onChange={e => setEditData({ ...editData, correct_option: e.target.value })}
                required
              >
                {[1,2,3,4].map(i => (
                  <option key={i} value={i}>{`Correct Option ${i}`}</option>
                ))}
              </select>
              <textarea
                className="rounded px-3 py-2 bg-gray-800 text-white border border-gray-700"
                placeholder="Explanation (optional)"
                value={editData.explanation || ''}
                onChange={e => setEditData({ ...editData, explanation: e.target.value })}
              />
            </div>
            {actionError && <div className="mt-3 text-red-400 font-semibold">{actionError}</div>}
            <button
              type="submit"
              className="mt-5 px-6 py-2 rounded bg-indigo-600 hover:bg-indigo-700 text-white font-semibold disabled:opacity-60"
              disabled={actionLoading}
            >
              {actionLoading ? 'Updating...' : 'Update Question'}
            </button>
          </form>
        </div>
      )}
      {/* Delete Alert Modal */}
      {deleteModal.open && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="bg-[#23272f] border border-gray-700 rounded-xl p-8 w-full max-w-md relative shadow-xl flex flex-col items-center">
            <span className="text-red-500 text-4xl mb-4">
              <svg width="2em" height="2em" viewBox="0 0 24 24" fill="none"><path d="M12 9v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </span>
            <h3 className="text-lg font-bold text-white mb-2">Delete Question?</h3>
            <p className="text-gray-300 mb-6 text-center">Are you sure you want to delete this question? This action cannot be undone.</p>
            <div className="flex gap-4">
              <button
                className="px-6 py-2 rounded bg-gray-700 hover:bg-gray-800 text-white font-semibold"
                onClick={() => setDeleteModal({ open: false, id: null })}
                disabled={actionLoading}
              >
                Cancel
              </button>
              <button
                className="px-6 py-2 rounded bg-red-600 hover:bg-red-700 text-white font-semibold disabled:opacity-60"
                onClick={confirmDeleteQuestion}
                disabled={actionLoading}
              >
                {actionLoading ? 'Deleting...' : 'Delete'}
              </button>
            </div>
            {actionError && <div className="mt-4 text-red-400 font-semibold">{actionError}</div>}
          </div>
        </div>
      )}
      </main>
    </div>
  );
}
